import moment from "moment";

const applicable = (resp) => resp.config.url.match(/api\/forms\/[0-9]*$/g);

// const testOptions = {
// 	endedInGrace: "ENDED_IN_GRACE",
// 	notStartedInGrace: "NOT_STARTED_IN_GRACE",
// 	endedNotInGrace: "ENDED_NOT_IN_GRACE"
// };

// const alterationMethods = {
// 	endedInGrace: (range, entity) => entity.Effective = {
// 		...range,
// 		End: moment().subtract(1, "month"),
// 		NoLaterThan: moment().add(1, "month"),
// 		NoEarlierThan: range.Start
// 	},
// 	endedNotInGrace: (range, entity) => entity.Effective = {
// 		...range,
// 		Start: moment().add(1, "month"),
// 		NoLaterThan: moment().add(12, "month"),
// 		NoEarlierThan: moment().subtract(1, "month")
// 	}
// notStartedInGrace: {
		
// }
// }; 

const addNotStartedInGrace = (entity) => {
	return entity.Effective = entity.Effective.map(range => ({
		...range,
		Start: moment().add(1, "month"),
		NoEarlierThan: moment().subtract(1, "month"),
		End: moment().add(1, "month"),
		NoLaterThan: moment().add(1, "month")
	})); 
};

const addEndedNotInGrace = entity => { 
	return entity.Effective = entity.Effective.map(range => ({
		...range,
		End: moment().subtract(1, "month"),
		Start: moment().subtract(3, "month"),
		NoLaterThan: moment().subtract(1, "month"),
		NoEarlierThan: moment().subtract(3, "month")
	})); 
};

const addEndedInGrace = entity => {
	return entity.Effective = entity.Effective.map(range => ({
		...range,
		End: moment().subtract(1, "month"),
		NoLaterThan: moment().add(1, "month"),
		NoEarlierThan: range.Start
	}));
};



const alterRanges = (alterMethod, entity) => {
	if(entity?.Effective) {
		// change effective ranges to add a variety of grace period test cases
		return alterMethod(entity);
		// return entity.Effective = entity.Effective.map(range => {
		// 	return {
		// 		...range,
		// 		Start: moment().add(1, "month"),
		// 		NoEarlierThan: moment().subtract(1, "month"),
		// 		End: moment().add(1, "month"),
		// 		NoLaterThan: moment().add(1, "month")
		// 	};
		// });
	}

	if(entity.Entities) {
		for(const related of entity.Entities) {
			alterRanges(alterMethod, related.Entity);
		}
	}

	return false;    
};

const modify = (alterMethod, resp) => {
	if(!resp.data?.Data) {
		return resp;
	}
	// const seasons = keyBy(resp.data.Data.Seasons ?? [], season => season.Code);
	for(const field of resp.data.Data.Fields || []) {
		if(field.Type?.IsEntity !== true) 
			continue;
        
		if(field.Data?.length < 1) {
			continue;
		}
		for(const entity of field.Data) {
			alterRanges(alterMethod, entity);
		}
	}

	return resp;
};

const modifyNotStartedInGrace = (resp) => modify(addNotStartedInGrace, resp);
const notStartedInGraceKey = "grace-period:before-start";

const modifyEndedNotInGrace = (resp) => modify(addEndedNotInGrace, resp);
const endedNotInGraceKey = "grace-period:none";

const modifyEndedInGrace = (resp) => modify(addEndedInGrace, resp);
const endedInGraceKey = "grace-period:ended";

export const gracePeriodAfterEnd = [endedInGraceKey, applicable, modifyEndedInGrace];
export const gracePeriodBeforeStart = [notStartedInGraceKey, applicable, modifyNotStartedInGrace];
export const gracePeriodNone = [endedNotInGraceKey, applicable, modifyEndedNotInGrace];